define('views/shared/panel/profile',[
    'backbone',
    'views/shared/panel/panel',
    'text!views/shared/panel/profile.html',
    'models/invite/campaign',
    'views/invite/invitationlist',
    'views/invite/invite',
    'views/shared/modal/modal_modern'
], function(Backbone, PanelView, Template, CampaignModel, InvitationList, InviteView, Modal){
    'use strict';

    return PanelView.extend({
        id      : 'profile-inner-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click .logout' : 'signOut',
            // 'click .js-close-secondary-container': 'showPanelHome'
        },
        initialize: function(options){
            options = options || {};
            
            this.is_open = false;
            this.panel_type = 1;
            this.elementName = options.elementName;

            PanelView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            // TODO: Fix the backbone native events object
            setTimeout(function(){
                that.$('.js-friends-family').on('click',that.showFfForm);
                that.$('.logout').on('click',that.signOut);
                that.$('.js-close-secondary-container').on('click',that.showPanelHome);
            }, 700);

            // Add Proxy/Account Number
            // this.$('.js-profile-settings-acc-num').html();

            return this;
        },

        loadData: function(){},

        updateData: function(){
            this.render();

            if(pf.session.get('auth')){
                this.checkInviteEligibility();
            }
        },

        checkInviteEligibility: function(){
            var that = this;
            this.invite_model = new CampaignModel();
            this.invite_model.fetch({
                success: function(model, resp){
                    var data = that.invite_model.toJSON();
                    
                    if(data.CanInvite){
                        that.$('.js-friends-family').css({ display: 'block' });
                        // if(render){
                        //     that.profileInvitations();
                        // }
                    }

                },
                error: function(){}
            });
        },

        profileInvitations: function(e){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            this.$("#profile_subnav a").removeClass("active");
            this.$("#profile_invitations").addClass("active");

            this.invitationListView = new InvitationList({ UGID: this.ID });
            this.loadView(this.invitationListView, ".content");
            return this;
        },

        showFfForm: function(e){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            // Show Friends & Family Form within a modal
            var invite_view = new InviteView(),
                modal = new Modal({
                    show        : true, // True, if we want the modal to show itself when it's ready
                    title       : 'Invite Friends & Family',
                    content     : invite_view.$el.html(),
                    calling_view: invite_view // Send in corresponding view to inherit events and custom properties
                });
        },

        signOut: function(e){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }
            console.log('signOut profile');

            pf.profile.destroy();
            pf.wallet.destroy();
            pf.transfer.destroy();

            pf.controller.signOut();
        },

        close: function(){}
    });
});

